import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRightIcon, ExclamationTriangleIcon } from "@heroicons/react/24/solid";

/**
 * Prominent notice when this product points to a successor (replaced_by_product).
 */
export function ProductReplacedBanner({ product }) {
  const { t } = useTranslation();
  const rep = product?.replaced_by_product;
  if (!rep?.id) return null;

  const label = [rep.item_number, rep.title].filter(Boolean).join(" — ");

  return (
    <div
      className="overflow-hidden rounded-xl border border-amber-300/80 bg-gradient-to-r from-amber-50 to-orange-50 shadow-md ring-2 ring-amber-200/60"
      role="status"
    >
      <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <div className="flex min-w-0 flex-1 gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-amber-500 text-white shadow">
            <ExclamationTriangleIcon className="h-7 w-7" aria-hidden />
          </div>
          <div className="min-w-0">
            <p className="text-base font-semibold text-amber-950">
              {t("product.replaced_by.banner_title")}
            </p>
            <p className="mt-1 text-sm text-amber-900/90">
              {t("product.replaced_by.banner_description")}
            </p>
            {label ? (
              <p className="mt-2 truncate text-sm font-medium text-amber-950 sm:whitespace-normal sm:break-words">
                {label}
              </p>
            ) : null}
          </div>
        </div>
        <Link
          to={`/dashboard/products/${rep.id}`}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-lg bg-amber-600 px-4 py-2.5 text-sm font-semibold text-white shadow transition hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2"
        >
          {t("product.replaced_by.open_replacement")}
          <ArrowRightIcon className="h-4 w-4" aria-hidden />
        </Link>
      </div>
    </div>
  );
}
